import { Component, Vue } from "vue-property-decorator";
import { VuejsDatatableFactory } from "vuejs-datatable";

Vue.use(VuejsDatatableFactory);

@Component
default class Footer extends Vue {

}
export default Footer